import * as actionTypes from "./dashboardTypes";

const INITIAL_STATE = {
    openTickets: [],
    ticketsCount: {},
    ticketCountByCategory: {},
    ticketCountByPriority: {},
    totalLogWorkMonthWise: [],
};

const supportDeskDashboardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETOPENTICKETS:
            return {
                ...state,
                openTickets: action.payload.list,
            };
        case actionTypes.SETTICKETSCOUNT:
            return {
                ...state,
                ticketsCount: action.payload.list,
            };
        case actionTypes.SETTICKETSCOUNTBYCATEGORY:
            return {
                ...state,
                ticketCountByCategory: action.payload.list,
            };
        case actionTypes.SETTICKETSCOUNTBYPRIORITY:
            return {
                ...state,
                ticketCountByPriority: action.payload.list,
            };
        case actionTypes.SETTOTALLOGWORKMONTHWISE:
            return {
                ...state,
                totalLogWorkMonthWise: action.payload.list,
            };
        case actionTypes.SUPPORTDESKDASHBOARDCLEARDOC:
            return {
                ...state,
                openTickets: [],
                ticketsCount: [],
                ticketCountByCategory: [],
                ticketCountByPriority: [],
                totalLogWorkMonthWise: []
            };
        default:
            return state;
    };
};

export default supportDeskDashboardReducer;